export default [{
  path: '/application',
  name: 'application',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/application/index')
}]
